(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-tah-fit-link]');
  if (!link) return;
  const panel = document.getElementById(link.getAttribute('href').slice(1));
  if (panel) { event.preventDefault(); panel.open = true; panel.scrollIntoView({block: 'nearest'}); }
});

  } catch(e) { console.error(e); }
})();
})();
